module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAUpJREFUOBHtVTFqhEAU/YYUgh4hESEpbBREL5FWwTpgkSrn8ACpshewszQeQhELbUyqLa0stBDRzMi6zM64GbfPh8E3773/cEZmFIAo27Zf0PRznudHgr4KBUE4IvEtTdOv1XS3gtPzsDcM+0/eA5lxT06Q4QHPXdcFz/NAkiRSPuNpmqCqKgiCANq2XXrOIgksy5odx5lRA8rmVxiGM+4hM+glg6IogPaG9FzFqqoyGhPIOG4k/gNv3LANO7OHfd9v2LaprusYgQksigLKsmSMNDEMA0RRRNNwcVKwOo4j+L4Puq7/eVLquoamafiBa2ie54x5D8EseatJlmXAY09xAzVNgyRJloExr7iBhmGAKIrLwJhXzEehG+I4BtM0FxpjXl1cK+gq+kYNT7wmSv/Jsux55eg3fEVX1wcSd/0CkO+Ibs33NQw/fwE0D4iXBNc2cgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/Login/login_email.png
// module id = 340
// module chunks = 0